<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

// Fetch route
const route = useRoute()
const eventUid = computed(() => route?.params?.eventsUid)
const centerRoute = computed(() => route.params?.centerUid)

// Fetch current event data
const { data: currentEvent, suspense: eventSuspense } = useFetchEventDetail(eventUid.value)

// Fetch center details
const { data: centerDetails, suspense: centerSuspense } = useFetchCenterDetails(centerRoute.value)

// Prefetch data on the server side
onServerPrefetch(async () => {
    await eventSuspense() // Wait for the event data to finish fetching
    await centerSuspense() // Wait for the center details to finish fetching
})

//  Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.CONTENT_DETAILS,
    centerUid: centerDetails.value?.centerUid,
    centerName: centerDetails.value?.centerName,
    contentTitle: currentEvent.value?.details?.title?.replace(/[*\n]/g, ''),
    contentType: TRACKING_CONSTANTS.MISC.EVENT,
})

// Seo
useSeoMeta({
    title: () => `${currentEvent.value?.details?.title} | ${staticKeys.value?.menu_news} | ${centerDetails.value?.centerName}`
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: true }">
        <ContentDetail :content="{ ...currentEvent, type: 'event' }" />
    </PageMainContainer>
</template>
